"use client";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GameControllerApiFactory } from "@/apis/game-management";
import { DefaultApiFactory } from "@/apis/transaction-management";
import InfinityTable from "@/components/Infinitytable";
import { LocalStorageKeys } from "@/constants/localStorage";
import { Card, Tabs } from "@atom/ui-kit";
import { useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { TransactionTabs } from "../transaction-management/TransactionManagement.constants";
import { columns } from "./GameManagement.columns";
import GameManagementFilterSpace from "./GameManagement.filters";
var DEFAULT_PAGE_SIZE = 15;
var GameManagement = function (_a) {
    var tableId = _a.tableId, gameId = _a.gameId, tableData = _a.tableData, userId = _a.userId, requestType = _a.requestType;
    var t = useTranslation().t;
    var _b = useState(false), loading = _b[0], setLoading = _b[1];
    var _c = useState([]), gameData = _c[0], setGameData = _c[1];
    var _d = useState(""), lastEvaluatedKey = _d[0], setLastEvaluatedKey = _d[1];
    var _e = useState({
        tenant: localStorage.getItem(LocalStorageKeys.TENANT) || "wisegaming",
        limit: DEFAULT_PAGE_SIZE,
        requestType: requestType || "gameId",
        userId: userId,
        tableId: tableId,
        lastEvaluatedKey: "",
    }), reqParams = _e[0], setReqParams = _e[1];
    var fetchGameData = function (lastEvaluatedKeyParam) { return __awaiter(void 0, void 0, void 0, function () {
        var response, newGames, _a, games, sortedGames, error_1;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    _c.trys.push([0, 13, 14, 15]);
                    setLoading(true);
                    response = void 0;
                    newGames = [];
                    _a = reqParams.requestType;
                    switch (_a) {
                        case "all": return [3 /*break*/, 1];
                        case "tableId": return [3 /*break*/, 3];
                        case "gameId": return [3 /*break*/, 5];
                        case "userId": return [3 /*break*/, 7];
                        case "gameName": return [3 /*break*/, 9];
                    }
                    return [3 /*break*/, 11];
                case 1: return [4 /*yield*/, GameControllerApiFactory().gamesGet(reqParams)];
                case 2:
                    response = (_c.sent());
                    newGames = tableId ? response.data.data.games.filter(function (game) { return game.tableId === tableId; }) : response.data.data.games;
                    setLastEvaluatedKey(response.data.lastEvaluatedKey);
                    return [3 /*break*/, 12];
                case 3: return [4 /*yield*/, GameControllerApiFactory().gamesTenantTenantTableTableIdGet({
                        tableId: reqParams.tableId,
                        tenant: reqParams.tenant,
                        limit: reqParams.limit,
                        lastEvaluatedKey: lastEvaluatedKeyParam || lastEvaluatedKey,
                    })];
                case 4:
                    response = _c.sent();
                    newGames = response.data.data.items;
                    setLastEvaluatedKey(response.data.data.lastEvaluatedKey);
                    return [3 /*break*/, 12];
                case 5: return [4 /*yield*/, GameControllerApiFactory().gamesTenantTenantIdIdGet({
                        id: reqParams.gameId,
                        tenant: reqParams.tenant,
                    })];
                case 6:
                    response = (_c.sent());
                    setGameData([response.data.data]);
                    return [2 /*return*/];
                case 7: return [4 /*yield*/, DefaultApiFactory().getUserTransactionsByTimestamp({
                        tenant: reqParams.tenant,
                        userId: reqParams.userId,
                        startTime: reqParams.startTime,
                        endTime: reqParams.endTime,
                        lastEvaluatedKey: lastEvaluatedKeyParam || lastEvaluatedKey,
                        limit: reqParams.limit,
                    })];
                case 8:
                    response = (_c.sent());
                    console.log(response.data, "response");
                    games = (_b = response.data.data.transactions) === null || _b === void 0 ? void 0 : _b.map(function (transaction) { return transaction === null || transaction === void 0 ? void 0 : transaction.game; }).filter(Boolean);
                    setLastEvaluatedKey(response.data.data.lastEvaluatedKey);
                    newGames = games;
                    return [3 /*break*/, 12];
                case 9: return [4 /*yield*/, GameControllerApiFactory().gamesTenantTenantNameNameGet({
                        name: reqParams.gameName,
                        tenant: reqParams.tenant,
                    })];
                case 10:
                    response = (_c.sent());
                    setGameData([response.data.data]);
                    return [3 /*break*/, 12];
                case 11: return [3 /*break*/, 12];
                case 12:
                    sortedGames = __spreadArray(__spreadArray([], gameData, true), newGames, true).sort(function (a, b) {
                        return new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime();
                    });
                    setGameData(sortedGames);
                    return [3 /*break*/, 15];
                case 13:
                    error_1 = _c.sent();
                    console.log(error_1);
                    return [3 /*break*/, 15];
                case 14:
                    setLoading(false);
                    return [7 /*endfinally*/];
                case 15: return [2 /*return*/];
            }
        });
    }); };
    var handleSearch = function (values) {
        setReqParams(function (prevParams) { return (__assign(__assign({}, prevParams), values)); });
    };
    var loadMore = useCallback(function () {
        if (["all", "tableId", "userId"].includes(reqParams.requestType) && lastEvaluatedKey) {
            fetchGameData(lastEvaluatedKey);
        }
    }, [fetchGameData, lastEvaluatedKey, reqParams.requestType]);
    useEffect(function () {
        fetchGameData();
    }, [reqParams]);
    useEffect(function () {
        setReqParams(function (prevParams) { return (__assign(__assign({}, prevParams), { gameId: gameId, requestType: requestType || "gameId", userId: userId, tableId: tableId })); });
    }, [gameId, requestType, userId, tableId]);
    console.log(gameData, "gameData", reqParams);
    return (_jsxs(Card, { style: { padding: "20px 0" }, children: [requestType !== "all" && !userId && requestType !== "tableId" && (_jsx(Tabs, { defaultActiveKey: reqParams.requestType === "gameId" ? "round" : "userId", items: TransactionTabs(t), size: "small", onChange: function (value) {
                    setReqParams(__assign(__assign({}, reqParams), { requestType: value === "round" ? "gameId" : "userId" }));
                    setGameData([]);
                } })), _jsx(GameManagementFilterSpace, { onSearch: handleSearch, requestType: reqParams.requestType, userId: userId }), _jsx(InfinityTable, { columns: columns(t, tableData), dataSource: gameData, loading: loading, hasMore: Boolean(lastEvaluatedKey), onLoadMore: loadMore })] }));
};
export default GameManagement;
